import {createRequestShield} from '@ni-ui-libs/botguard-sdk';
import {TrackEventUBA} from './analytics';

type BotGuardInstance = ReturnType<typeof createRequestShield>;

let instance: BotGuardInstance | null = null;
let cachedToken: string = '';

// Runtime toggle: set `botGuardEnabled: true` in feature-flag.json on the CDN.
// Build-time hard-stop: NEXT_PUBLIC_BOTGUARD_PUBLIC_KEY must be set for the SDK to work.
export const isBotGuardEnabled = (): boolean => {
  if (!process.env.NEXT_PUBLIC_BOTGUARD_PUBLIC_KEY) return false;
  if (typeof window === 'undefined') return false;
  return Boolean(window.__FEATURE_FLAGS__?.botGuardEnabled);
};

export const getBotGuardInstance = (): BotGuardInstance | null => {
  console.log('[BotGuard] isBotGuardEnabled', isBotGuardEnabled());
  if (!isBotGuardEnabled()) return null;
  console.log('[BotGuard] Initializing BotGuard instance');
  if (!instance) {
    instance = createRequestShield({
      appId: process.env.NEXT_PUBLIC_UBA_APP_ID!,
      publicKey: process.env.NEXT_PUBLIC_BOTGUARD_PUBLIC_KEY!,
      // logger: console,
      ubaCallback: ({payload, type}) => {
        const actionType = 'view';
        TrackEventUBA('niBotGuardCaptchaEvent', actionType, {
          payload: JSON.stringify(payload),
          type,
        });
      },
    });
  }
  return instance;
};

export const getDynamicToken = async (
  pageUID: string
): Promise<string | null> => {
  const bg = getBotGuardInstance();
  if (!bg) return null;
  const token = await bg.getDynamicToken(pageUID, () => null);
  if (token) cachedToken = token;
  return token;
};

export const getCachedBotToken = (): string => cachedToken;
